/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';
import * as mTypes from 'store/mutation-types';

const state = {
  parkings: [],
  error: null,
};

const getters = {
  parkings: state => state.parkings,
  error: state => state.error,
};

const actions = {
  fetchConference({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.get(`${process.env.BACKEND_API_URL}api/${path}/parkings/conference/${payload.id}`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      });
  },
};

const mutations = {
  [mTypes.DATA_FETCHED](state, parkings) {
    state.parkings = [];
    if (parkings.data) {
      parkings.data.forEach((el) => {
        state.parkings.push(el);
      });
    }
    state.error = null;
  },
  [mTypes.REMOVE_DATA](state, parkingId) {
    const index = state.parkings.findIndex(obj => obj.id === parkingId);
    state.parkings.splice(index, 1);
  },
  [mTypes.CLEAR_STATE](state) {
    state.parkings = [];
  },
  [mTypes.DATA_ERROR](state, error) {
    state.error = error === null ? error : error.data.message;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/parkings/parkings.js